export default "__VITE_ASSET__0eMQNgMo__"